import { Collapse, Grid, styled, useTheme } from "@mui/material";
import React from "react";
import {
  IconAlertTriangleFilled,
  IconCaretDownFilled,
  IconInfoCircle
} from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import MxTooltipContent from "@rf-l1/tooltip/MxTooltipContent";
import MxIcons from "@rf-l1/MxIcons";
interface ContentSectionProps {
  title: string;
  tooltip: string;
  children?: React.ReactNode;
  defaultExpanded?: boolean;
  color?: "blue" | "grey";
  alert?: boolean;
}
const ContentSection = (props: ContentSectionProps) => {
  const [expanded, setExpanded] = React.useState(props.defaultExpanded ?? false);
  const theme = useTheme();
  const toggleExpanded = () => {
    setExpanded(prev => !prev);
  };

  return (
    <MainContent in={expanded} collapsedSize={60} >
      <Grid container>
        <ContentHeader
          container
          sx={{
            background:
              props.color === "blue"
                ? theme.palette.primary.main
                : theme.palette.grey[500]
          }}
          onClick={toggleExpanded}
          alignItems="center"
          gap={2}
        >
          <Grid item xs="auto" mb={0.4}>
            <MxTypography color="white" variant="subtitle2" fontWeight={500}>
              {props.title}
            </MxTypography>
          </Grid>

          {props.tooltip && (
            <Grid item xs="auto">
              <MxTooltipContent
                sx={{ width: 200 }}
                template={
                  <Grid>
                    <MxTypography
                      variant="overline"
                      color="primary.main"
                      fontWeight={600}
                    >
                      {props.tooltip}
                    </MxTypography>
                  </Grid>
                }
              >
                <MxIcons size={14} color="#fff">
                  <IconInfoCircle />
                </MxIcons>
              </MxTooltipContent>
            </Grid>
          )}

          {props?.alert && (
            <Grid item xs="auto" alignItems="center">
              <MxIcons size={14} color="warning.main">
                <IconAlertTriangleFilled />
              </MxIcons>
            </Grid>
          )}

          <Grid item flex={1} />

          <Grid item xs="auto" mt={0.5}>
            <IconCaretDownFilled
              color="#fff"
              size={18}
              className={expanded ? "rotate-180" : "rotate-0"}
            />
          </Grid>
        </ContentHeader>

        <ContentBody item xs={12}>
          {props.children}
        </ContentBody>
      </Grid>
    </MainContent>
  );
};

export default ContentSection;

const MainContent = styled(Collapse)(({ theme }) => ({
  borderRadius: 20,
  margin: "15px 0px",
  width: "100%"
}));

const ContentHeader = styled(Grid)(({ theme, hidden }) => ({
  padding: theme.spacing(1, 2),
  cursor: "pointer",
  background: theme.palette.primary.main,
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  height: "4rem",
  "& svg": {
    transition: "transform 0.3s"
  },
  "& .rotate-180": {
    transform: "rotate(180deg)"
  },
  "& .rotate-0": {
    transform: "rotate(0deg)"
  }
}));

const ContentBody = styled(Grid)(({ theme }) => ({
  // borderColor: ,
  border: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(3, 4),
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px"
}));
